import AppStore from '@v4/store/appStore'
import PageTemplateData from '@v4/utils/data/PageTemplateData'
import { useMemo } from 'react'

export const useMainContainer = ({ relatedSections, ...rootProps }) => {
	const minMarginTop = AppStore.useStoreState(state => state.ui.sectionHeights[relatedSections[0]])
	const minMarginBottom = AppStore.useStoreState(state => state.ui.sectionHeights[relatedSections[1]])

	const margins = useMemo(
		() => ({
			top: minMarginTop || 0,
			bottom: minMarginBottom || 0,
		}),
		[minMarginBottom, minMarginTop],
	)

	return [
		{
			minMarginTop: relatedSections[0] === PageTemplateData.SORT_GROUPS.HEADER ? minMarginTop : null,
			minMarginBottom: relatedSections[1] === PageTemplateData.SORT_GROUPS.FOOTER ? minMarginBottom : null,
			rootProps,
			margins,
		},
	]
}
